// extracted by mini-css-extract-plugin
export default {"container":"ced9ebywm","holder":"clxlde77w","noMarginTop":"cy7518rwd"};